import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { BASE_URL, responseError, scoringRoundActionId, toastError } from "../../../utils/constants";
import Header from "../../../common_components/Header";
import { fill_action } from "../../../actions/common_action/fillList_action";
import 'react-datepicker/dist/react-datepicker.css';
import Footer from "../../../common_components/Footer";
import { get_dashboard_data_action } from "../../../actions/common_action/dashboard_action";
import moment from "moment";
import MobileHeader from "../../../common_components/mobileHeader";

class JuryDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            user_id: "",
            jury_id: "", application_form_id: '',
            juryDashboardData: [],
            circularData: [],
            downloadUrl: '',
            juryData: [],
            round_id: '',
            roundFillList: [], juryReviewEndDate: '',
            daysToGo: '',

        };
    }
    componentDidMount() {
        const tempData = localStorage.getItem("tempLoginData");

        if (tempData) {
            const userData = JSON.parse(tempData);
            sessionStorage.setItem("AwardsUserLoginData", JSON.stringify(userData));
            sessionStorage.setItem("loginAccesslist", JSON.stringify(userData["loginAccesslist"]));
            sessionStorage.setItem("user_id", userData["user_id"]);
            sessionStorage.setItem("email_address", userData["email_address"]);
            sessionStorage.setItem("user_name", userData["user_name"]);
            sessionStorage.setItem("role_id", userData["role_id"]);
            sessionStorage.setItem("jury_id", userData["jury_id"]);
            sessionStorage.setItem("accessToken", userData["accessToken"]);
            sessionStorage.setItem("refreshToken", userData["refreshToken"]);
            localStorage.removeItem("tempLoginData");
        }
        setTimeout(() => {
            if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
                setTimeout(() => {
                    this.props.navigate("/login");
                }, 500);
                return;
            }
            setTimeout(() => {
                if (sessionStorage.getItem("role_id") == 1) {
                    this.props.navigate("/login");
                }
            }, 10);

            const { user_id } = this.state;
            const sortUrl = BASE_URL.split("/api");
            this.setState({ downloadUrl: sortUrl[0] });
            const waitForAwardEventId = () => {
                const awardEventId = sessionStorage.getItem("award_event_id");
                if (awardEventId != null) {
                    this.getFillList(scoringRoundActionId, user_id, "", "");
                    setTimeout(() => {
                        this.getDashboardData();
                    }, 500);
                } else {
                    setTimeout(waitForAwardEventId, 200);
                }
            };
            waitForAwardEventId();
        }, 200);
    }

    getFillList(value, user_id, keyword, keyvalue) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(
                value,
                user_id == "" || user_id == null ? null : user_id,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == scoringRoundActionId) {
                        this.setState({
                            roundFillList: data.data,
                        });
                    }

                } else {
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    getDashboardData = () => {
        const { } = this.state;
        this.setState({ isLoading: true });
        this.props.get_dashboard_data_action(null, null, sessionStorage.getItem("jury_id"))
            .then((data) => {
                if (data.error !== 1) {
                    const juryReviewEndDate = data?.data?.[0]?.[0]['juryReviewEndDate'];
                    const today = new Date(); // Current local date and time
                    const reviewEndDate = new Date(juryReviewEndDate); // Provided date in ISO format
                    const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
                    const reviewEndDateUTC = Date.UTC(reviewEndDate.getFullYear(), reviewEndDate.getMonth(), reviewEndDate.getDate());
                    const difference = reviewEndDateUTC - todayUTC;
                    const daysToGo = Math.max(0, Math.ceil(difference / (1000 * 60 * 60 * 24)));
                    this.setState({
                        juryDashboardData: data.data[1],
                        circularData: data.data[2],
                        isLoading: false,
                        juryReviewEndDate,
                        daysToGo,
                        currentpage: 1,
                    });
                } else {
                    this.setState({ isLoading: false });
                    if (data.msg == "Session expired! Please login again." || data.msg == "Token invalid") {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    navigateReview(award_event_profile_id, award_name, application_status_id, status_name) {
        this.props.navigate("/juryReview", {
            state: { award_event_profile_id, award_name, application_status_id, status_name }
        });
    }
    render() {
        const { isLoading, juryDashboardData, circularData, roundFillList, round_id, juryData, downloadUrl, juryReviewEndDate, daysToGo } = this.state;
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        <section class='header_margin_top'>
                            <div className="container-fluid main-box">


                                <div className="row mt-3" style={{ display: 'flex' }}>
                                    <div className="col-9" style={{ flex: '1 1 auto' }}>
                                        <div class="page-header mb-0">
                                            <h2 className="mb-2 dashboard-tit  py-0 blog-name blog-name-1">Dashboard</h2>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="d-flex">
                                                    <label className="dashboard-tit w-auto mr-4 mt-2">Round</label>
                                                    <select
                                                        className="form-select"
                                                        name="TimeSlot"
                                                        value={round_id}
                                                        onChange={(e) => {
                                                            this.setState({ round_id: e.target.value });
                                                        }}
                                                    >
                                                        {roundFillList.map((data) => (
                                                            <option value={data.round_id}>{data.round_name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <label className="dashboard-tit mt-1">No of days to go: <span className="label-no">{daysToGo}</span></label>
                                            </div>
                                            <div className="custom_table mt-1">
                                                <div className="hack1">
                                                    <div className="hack2">
                                                        <table className="table table-bordered" id="dashboard-table">
                                                            <thead>
                                                                <tr style={{ background: "#E6E6E6" }}>
                                                                    <th style={{ width: "55%" }}>Category</th>
                                                                    <th style={{ width: "15%", textAlign: 'center' }}>Total Count</th>
                                                                    {/* <th style={{ width: "15%", textAlign: 'center' }}>Partial Reviewed</th> */}
                                                                    <th style={{ width: "15%", textAlign: 'center' }}>Reviewed</th>
                                                                    <th style={{ width: "15%", textAlign: 'center' }}>Pending</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody id="myTable">
                                                                {juryDashboardData.length > 0 ? (
                                                                    juryDashboardData.map((data, rowIndex) => {
                                                                        return (
                                                                            <tr key={rowIndex}>
                                                                                <td>{data.award_name}</td>
                                                                                <td className="text-center" style={{ color: '#062EC1' }}><a onClick={() => this.navigateReview(data.award_event_profile_id, data.award_name, '5,6,7', 'Not Reviewed,Partial Reviewed,Reviewed')}>{data.total}</a></td>
                                                                                {/* <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }}><a onClick={() => this.navigateReview(data.award_event_profile_id, data.award_name, '6', 'Partial Reviewed')}>{data.partial_reviewed}</a></td> */}
                                                                                <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }}><a onClick={() => this.navigateReview(data.award_event_profile_id, data.award_name, '7', 'Reviewed')}>{data.total_reviewed}</a></td>
                                                                                <td className="text-center" style={{ cursor: 'pointer', color: '#062EC1' }}><a onClick={() => this.navigateReview(data.award_event_profile_id, data.award_name, '5,6', 'Not Reviewed,Partial Reviewed')}>{data.total_pending}</a></td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className="text-center">
                                                                            No records found
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{ flex: '0 0 25%', display: 'flex', flexDirection: 'column' }}>
                                        <h2 className="mb-3 dashboard-tit  py-0 blog-name blog-name-1">Circular</h2>
                                        <div className="circular border circular-height" style={{ flex: '1', overflow: "scroll", marginTop: '40px' }}>
                                            {circularData?.length > 0 ? (
                                                circularData.map((data, i) =>
                                                    data.circular_id ? (
                                                        <div key={i} className="aside-group border-bottom mb-2">
                                                            <ul className="p-0 m-0">
                                                                <li className="d-flex justify-content-between align-items-center">
                                                                    <span className="tit-name" style={{ overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                                        {data.title}
                                                                    </span>
                                                                    <span className="tit-date">{moment(data.circular_date).format('DD-MM-YYYY')}</span>
                                                                </li>
                                                                <li className="tit-date pb-2" style={{ overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                                    {data.content}
                                                                </li>
                                                                <li className="tit-date pb-2 membership_file">
                                                                    <a href={`${downloadUrl + data.file_path}`} target="_blank" rel="noopener noreferrer">
                                                                        {data.file_path?.split('/').pop()}
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    ) : null
                                                )
                                            ) : (
                                                <div className="aside-group border-bottom">
                                                    <ul className="p-0 m-0">
                                                        <li className="tit-date"> </li>
                                                        <li className="tit-name"> No Circular Released</li>
                                                        <li className="tit-date pb-2"></li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <ToastContainer />
                </>
            </>
        );
    }
}
const mapDispatchToProps = {
    fill_action, get_dashboard_data_action
};

export default withRouter(
    connect(null, mapDispatchToProps)(JuryDashboard)
);
